module.exports = __webpack_public_path__ + "static/media/top-shadow.a63cfb1f.svg";